'use strict';

var ChartDemandTransparencyDirective = function ChartDemandTransparencyDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-demand-transparency.html'),
    controller: 'ChartDemandTransparencyController',
    scope: {
      attributes: '=',
      dimension: '=',
      selectedMetric: '=',
      quickFilterData: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.chartFormatters);
      scope.renderChartDataPresent = function (data, selectionSize) {
        chart.withMetric(scope.selectedMetric).setSelection(selectionSize).render(data);
        viewport.render(data, selectionSize);
      };
      scope.updateChart = function () {
        chart.render(scope.data);
        viewport.render(scope.data);
      };
      chart.on('rangechange', function (ranges) {
        scope.onRangeChange(ranges);
      });

      // brush change in the viewport chart affects what's visible in the main chart
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
      function resetChartHandler() {
        var argumentsReady = scope.attributes && scope.dimension && scope.quickFilterData;
        scope.setLoadingMessage(argumentsReady ? 'Loading' : 'No data found');
        if (element.is(':visible') && argumentsReady) {
          scope.initChart();
        }
      }
      function redrawChartHandler() {
        var argumentsReady = scope.attributes && scope.dimension && scope.quickFilterData;
        scope.setLoadingMessage(argumentsReady ? 'Loading' : 'No data found');
        if (element.is(':visible') && argumentsReady) {
          scope.redrawChart();
        }
      }
      scope.$watch('attributes', resetChartHandler);
      scope.$watch('dimension', resetChartHandler);
      scope.$watch('quickFilterData', redrawChartHandler, true);
    }
  };
};
ChartDemandTransparencyDirective.$inject = ['ChartDemandTransparency', 'ChartDemandTransparencyViewport'];
module.exports = ChartDemandTransparencyDirective;